<mat-form-field>
  <mat-select [formControl]="control" placeholder="Périodes" multiple>
    <mat-option value="AN">Annuelle</mat-option>
    <mat-option value="A">Automne</mat-option>
    <mat-option value="P">Printemps</mat-option>
  </mat-select>
</mat-form-field>
